import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  /**
   * Génération des tarifs
   *
   * @return  {void}
   */
  getRate() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
    };

    return Network.execute('GET', 'CWEBS0056A', data);
  },
  getProduct(query, pnlot) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnlot,
      fmod: query
    };

    return Network.execute('GET', 'CWEBS0058A', data);
  },
  getProductSize(query, pnlot, pmod) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnlot,
      pmod,
      ftail: query
    };

    return Network.execute('GET', 'CWEBS0059A', data);
  },
  getCustomerRate(query_data) {
  
    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      plimit: 20,
      ...query_data
    };

    return Network.execute('GET', 'CWEBS0057A', data);
  },
  getRateDownload(pnlot) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnlot
    };

    return Network.execute('GET', 'CWEBS0075A', data, {}, {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    }, 'arraybuffer');
  }
}